(() => {
  const content = document.querySelector('[data-article-content]');
  const toc = document.querySelector('[data-article-toc]');
  const list = document.querySelector('[data-article-toc-list]');

  if (!content || !toc || !list) return;

  const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
  if (!headings.length) return;

  const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
  const slugify = (text) => text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s-]+/g, '-')
    .replace(/^-|-$/g, '') || 'section';

  let sectionNumber = 0;
  let subsectionNumber = 0;

  headings.forEach((heading, index) => {
    if (!heading.id) {
      const base = slugify(heading.textContent);
      let id = base;
      let suffix = 2;
      while (usedIds.has(id)) id = `${base}-${suffix++}`;
      heading.id = id;
      usedIds.add(id);
    }

    const item = document.createElement('li');
    item.className = `article-toc__item article-toc__item--${heading.tagName.toLowerCase()}`;
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    link.dataset.tocIndex = index;
    if (heading.tagName === 'H2') {
      sectionNumber += 1;
      subsectionNumber = 0;
      link.dataset.tocNumber = `${sectionNumber}`;
    } else {
      if (sectionNumber === 0) sectionNumber = 1;
      subsectionNumber += 1;
      link.dataset.tocNumber = `${sectionNumber}.${subsectionNumber}`;
    }
    item.appendChild(link);
    list.appendChild(item);
  });

  toc.hidden = false;
  const details = toc.querySelector('details');
  const mobile = window.matchMedia('(max-width: 767px)');
  const setDisclosure = () => { details.open = !mobile.matches; };
  setDisclosure();
  mobile.addEventListener('change', setDisclosure);

  list.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;
    const heading = headings[Number(link.dataset.tocIndex)];
    if (!heading) return;
    event.preventDefault();
    heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', `#${encodeURIComponent(heading.id)}`);
  });

  const links = [...list.querySelectorAll('a')];
  const setActive = (heading) => {
    links.forEach((link, index) => {
      const active = headings[index] === heading;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };

  const observer = new IntersectionObserver((entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (visible.length) setActive(visible[0].target);
  }, { rootMargin: '-20% 0px -65% 0px' });

  headings.forEach((heading) => observer.observe(heading));
  setActive(headings[0]);
})();
